import styled from 'styled-components'
import { fonts } from '../../../app-v2/design-systems'
import { colors } from 'shared/assets/styles'
import { repeatedTextShadow } from '../utils'

export const StyledTiltedTextContainer = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
`
export const StyledTPKTitle = styled.h2`
    font-size: ${props => (props.isSmallScreen ? '1.1rem' : '1.3rem')};
    font-family: ${fonts.flameBold};
    color: ${colors.white};

    ${props =>
        !props.noTextShadow
            ? `text-shadow: ${repeatedTextShadow(2, props.borderColor)};`
            : ''}

    padding: 8px 16px;
    background: ${props => props.backgroundColor};
    border: 2px solid ${props => props.borderColor};
    border-radius: 10px;
    box-shadow: 0 6px 0 ${props => props.borderColor};
`
export const StyledTiltedText = styled(StyledTPKTitle)`
    transform: ${props => props.tiltedLeft && `rotateZ(-3deg)`}
        ${props => props.tiltedRight && `rotateZ(1deg)`}
        ${props => props.shiftLeft && 'translateX(-5%)'}
        ${props => props.shiftRight && 'translateX(5%)'};
`

export const StyledText = styled.p`
    font-size: 16px;
    color: ${colors.bbqBrown};
    margin: 0;
    font-family: ${fonts.flameSansRegular};
    text-align: center;
    width: 100%;
`

export const StyledLink = styled.a`
    text-decoration: underline;
    &:hover,
    &:active {
        text-decoration: underline;
    }
`
